import { EditorState, Modifier } from 'draft-js';
import { Map } from 'immutable';
import { isHighlightedBlock } from '../block';

var highlightToggle = function highlightToggle(editorState) {
  var contentState = editorState.getCurrentContent();
  var selectionState = editorState.getSelection();
  var firstBlock = contentState.getBlockForKey(selectionState.getStartKey());
  var highlighted = isHighlightedBlock(firstBlock) ? false : true; //Toggle highlight

  return EditorState.push(editorState, Modifier.mergeBlockData(contentState, selectionState, Map({
    highlighted: highlighted
  })), 'change-block-data');
};

export default highlightToggle;